import { Pages } from "layouts/Pages/Pages.jsx";

import { Dashboard } from "layouts/Dashboard/Dashboard.jsx";

import { projectConstants } from '../constants';

var indexRoutes = [
  { path: "/pages", name: "Pages", component: Pages, isPrivate: false },
  { path: "/", name: "Home", component: Dashboard, isPrivate: true },
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx